import { observables, DataPool, Subjects } from "./observables";

export default class StateTree {
    static getSubject(key) {
        return Subjects[key];
    }

    static getDataPool() {
        return DataPool;
    }

    static catalogue(key) {
        return observables[key];
    }

    static update(key, overwriteData) {
        try {
            this.updateDataPool(overwriteData, key, true);
            if (!observables[key]) return;
            observables[key].next(overwriteData);
        } catch (e) {
            console.log(e);
        }
    }

    static updateDataPool(data, key, dataPool) {
        try {
            if (!data) return;

            const currentData = DataPool.getValue();

            if (key && !dataPool) {
                const subject = Subjects[key];

                if (!subject) {
                    console.log("Missing behavior subject");
                    return;
                }

                subject.next(data);
                return;
            }

            let updateObj = { ...currentData };

            if (key) {
                updateObj[key] = data;
            } else {
                updateObj = { ...currentData, ...data };
            }

            DataPool.next(updateObj);
        } catch (e) {
            console.log(e);
        }
    }

    static subscribe(key, subscriptionFunction) {
        if (!observables[key]) return;
        observables[key].subscribe(subscriptionFunction);
    }
}
